export default "__VITE_ASSET__TLGrO4WU__"